import { DatePipe } from "@angular/common";
import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import { BlockComponent } from "@components/container-block/block.component";
import { HeaderComponent } from "@components/header/header.component";
import { MeddelandeInfotavlaDTO } from "~app/common/models/meddelandeInfotavla/MeddelandeInfotavlaDTO";
import { StringLinkifyPipe } from "../../../../common/pipes/string-linkify.pipe";

@Component({
    selector: "rask-systemaktivitet-container",
    templateUrl: "./systemaktivitet-container.component.html",
    styleUrls: ["./systemaktivitet-container.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        BlockComponent,
        HeaderComponent,
        DatePipe,
        StringLinkifyPipe
    ]
})
export class SystemaktivitetContainerComponent {
  @Input() systemaktivitet: MeddelandeInfotavlaDTO;
}
